module.exports = __webpack_public_path__ + "img/list.fd99ff50.svg";